import { fetch, Method, getPaging } from 'core/api/fetch';

const ExperiencerDocsRoutes = {
    get: (id) => `/api/v1.1.1/admin/experiencer/${id}/docs`,
    savePDF: (id) => `/api/v1.1.1/admin/experiencer/${id}/docs`,
    update: (experiencerId, docId) =>
        `/api/v1.1.1/admin/experiencer/${experiencerId}/docs/${docId}`,
};

export const ExperiencerDocsService = {
    getExperiencerDocs: async (experiencerId) => {
        try {
            const { data } = await fetch(ExperiencerDocsRoutes.get(experiencerId), {
                method: Method.GET,
                authenticated: true,
            });

            return data;
        } catch (error) {
            throw new Error(error);
        }
    },

    savePDF: async (experiencerId, newData) => {
        try {
            const formData = new FormData();
            formData.append('pdfFile', newData?.file);
            if (newData?.documentName) {
                formData.append('name', newData.documentName);
            }
            if (newData?.version) {
                formData.append('version', newData.version);
            }
            if (newData?.expiryDate) {
                formData.append('expiryDate', newData.expiryDate);
            }
            if (newData?.docStatus) {
                formData.append('docStatus', newData.docStatus);
            }
            if (newData?.typeId) {
                formData.append('typeId', newData.typeId);
            }

            await fetch(ExperiencerDocsRoutes.savePDF(experiencerId), {
                method: Method.POST,
                authenticated: true,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return true;
        } catch (err) {
            console.error(err);
            return false;
        }
    },
    updateExperiencerDoc: async (experiencerId, docId, updatedFields) => {
        try {
            await fetch(ExperiencerDocsRoutes.update(experiencerId, docId), {
                method: Method.PATCH,
                authenticated: true,
                data: updatedFields,
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return true;
        } catch (err) {
            console.error(err);
            return false;
        }
    },
};
